import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-50'>
      <div className='max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center'>
        <div className='mb-6'>
          <div className='text-6xl mb-4'>🔒</div>
          <h1 className='text-3xl font-bold text-gray-900 mb-2'>
            Access Denied
          </h1>
          <p className='text-gray-600'>
            You don't have permission to access this page.
          </p>
        </div>

        <div className='bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6'>
          <p className='text-sm text-yellow-800'>
            <strong>Note:</strong> This area requires special permissions. If
            you believe you should have access, please contact your
            administrator.
          </p>
        </div>

        <div className='space-y-3'>
          {/* `/` sends each role to its own home (the studio for coaches). */}
          <Link
            to='/'
            className='inline-block w-full bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors'
          >
            Go to Dashboard
          </Link>

          <Link
            to='/'
            className='inline-block w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition-colors'
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
